import { Locale, useI18n } from 'vue-i18n';
import useExercises from '@/services/useExercises';
import useLocalStorage from '@/services/useLocalStorage';
import { WritableComputedRef, reactive, toRefs } from 'vue';

const { getCurrentLocale, setCurrentLocale } = useLocalStorage();

const setup = () => {
  const { locale: useI18nLocale, availableLocales: useI18nAvailableLocales } = useI18n({ useScope: 'global' });

  const state = reactive({
    locale: useI18nLocale as WritableComputedRef<Locale>,
  });

  const resolveLocale = (lang: string): string => {
    if (useI18nAvailableLocales.includes(lang)) return lang;
    return useI18nAvailableLocales.find((l) => l.split('-')[0] === lang);
  };

  const setLocale = (lang: string) => {
    const resolvedLang = resolveLocale(lang);
    state.locale = resolvedLang as Locale;
    document.documentElement.setAttribute('lang', resolvedLang);
    setCurrentLocale(resolvedLang);
    useExercises().setLanguage(resolvedLang);
  };

  return {
    ...toRefs(state),
    getCurrentLocale,
    setLocale,
  };
};

export default () => ({
  ...setup(),
});
